import React, { useEffect, useState, useCallback } from 'react';
import Header from '../../components/Header';
import { Aside } from '../../components/Aside';
import Dash from '../../components/Dash';
import { GlobalStyle } from '../../styles/global';
import Modal from '../../components/Modal';
import { useParams } from "react-router-dom";
import toast from 'react-hot-toast';
import {api} from '../../services/api';
import Loading from '../../components/Loading';

interface DataUser{
  email: string
}

const Alunos: React.FC = () => {

  const [load, setLoad] = useState(true);

  const { email } = useParams<DataUser>();
  

  const [showmodal, setShowmodal] = useState(false);
  const [datamodal] = useState({})
  const [updateCiclo, setUpdateciclo] = useState(false);  


  const [aluno, setAluno] = useState({});
  
  const getUser = useCallback(async (email: string) => {           
    try {       
      const params = { email : email } 
     
        const resp = await api.get('/users/getInfoAluno.php', { params : params });
        setAluno(resp.data[0]); 
        setLoad(false);
    } catch (err: any) {           
        const resp = err.response.statusText ? err.response.statusText : 'ERRO AO TENTAR ATUALIZAR';
        toast.error(resp + ', POR FAVOR ATUALIZE A PÁGINA');
    }            
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  
  useEffect(() => {
    let mounted = true;
    if(mounted){
      getUser(email);
    }
    return function cleanup() {
        mounted = false
    }
  }, [email, getUser]);

  return (
    <>
    {!load ? (
    <>
        <Modal 
          show={showmodal} 
          setShowmodal={() => 
          setShowmodal(!showmodal)} 
          datamodal={datamodal} 
          setUpdateciclo={() => setUpdateciclo(!updateCiclo) } 
        />
        <Header />
        <Aside />
        <Dash aluno={aluno} />
        <GlobalStyle />
    </>
    ) : (
      <Loading />
    )}
    </>
   );
}

export default Alunos;